(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dinuzo-money"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dinuzo-money')) {
  customElements.define('dinuzo-money', class extends HTMLElement {
    static get observedAttributes() { return ['amount', 'currency', 'locale', 'country']; }
    connectedCallback() { queueMicrotask(() => this.format()); }
    attributeChangedCallback() { if (this.isConnected) this.format(); }
    format() {
      const amount = Number(this.getAttribute('amount'));
      const currency = this.getAttribute('currency');
      if (!Number.isFinite(amount) || !currency) return;
      const language = this.getAttribute('locale') || document.documentElement.lang || 'en';
      const country = this.getAttribute('country');
      const locale = language.includes('-') || !country ? language : language + '-' + country;
      try {
        const formatted = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount / 100);
        let content = this.querySelector('bdi');
        if (!content) { content = document.createElement('bdi'); this.append(content); }
        content.textContent = formatted;
      } catch {}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
